export default __webpack_public_path__ + "static/media/1893.d781dd94.png";